// extracted by mini-css-extract-plugin
export default {"test-form":"WlYYAHujGX","testForm":"WlYYAHujGX"};